import { render } from "./Widget5.vue?vue&type=template&id=7758d352"
import script from "./Widget5.vue?vue&type=script&lang=ts"
export * from "./Widget5.vue?vue&type=script&lang=ts"
script.render = render

export default script